export const error = {
  isRequired: 'This field is required',
  email: 'Please enter valid email address',
  minlength: 'The no. of characters should not be less than {{requiredLength}}',
};
